
import { subsidiariesData } from '../../../mocks/subsidiaries';

export default function Subsidiaries() {
  return (
    <section id="subsidiaries" className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <div className="w-16 h-1 bg-[#D4A574] mx-auto mb-4"></div>
            <h2 className="text-5xl md:text-6xl font-bold text-[#2C1810] font-['Space_Mono'] tracking-tight">
              MINISTRY OUTREACH
            </h2>
            <div className="w-16 h-1 bg-[#D4A574] mx-auto mt-4"></div>
          </div>
          <p className="text-base text-[#5C4033] max-w-2xl mx-auto font-['DM_Sans'] mt-6 tracking-wide">
            SERVING COMMUNITIES THROUGH DIVERSE PROGRAMS
          </p>
          <div className="border-4 border-[#2C1810] p-6 max-w-3xl mx-auto mt-8 bg-[#F5E6D3]">
            <p className="text-sm text-[#2C1810] leading-relaxed font-['Crimson_Text'] italic">
              "Each of you should use whatever gift you have received to serve others, as faithful stewards of God's grace in its various forms."
            </p>
            <p className="text-xs text-[#D4A574] font-['Space_Mono'] mt-3 tracking-wider">
              — 1 PETER 4:10
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {subsidiariesData.map((subsidiary, index) => (
            <div 
              key={index}
              className="group cursor-pointer"
            >
              <div className="border-4 border-[#2C1810] overflow-hidden bg-white hover:border-[#D4A574] transition-all">
                <div className="relative h-64 w-full overflow-hidden">
                  <img 
                    src={subsidiary.image}
                    alt={subsidiary.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-[#2C1810]/0 group-hover:bg-[#2C1810]/20 transition-all"></div>
                </div>
                <div className="p-6 bg-[#F5E6D3]">
                  <div className="mb-3">
                    <span className="text-xs font-['Space_Mono'] text-[#D4A574] tracking-widest">
                      {subsidiary.category.toUpperCase()}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-[#2C1810] mb-3 font-['Space_Mono'] leading-tight">
                    {subsidiary.name}
                  </h3>
                  <p className="text-xs text-[#5C4033] font-['DM_Sans'] leading-relaxed">
                    {subsidiary.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
